import React, { useState } from "react";
import { ArrowUpDown } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { Progress } from "@/components/ui/progress";
import { ReorderExercisesDialog } from "@/components/ReorderExercisesDialog";

export function DayHeading() {
  const { state, activeDay, daily, dailyProgress, reorderExercises } = useApp();
  const [reorderOpen, setReorderOpen] = useState(false);

  if (!state) return null;

  const currentDay = state.routine[activeDay];
  // Cuentas nuevas empiezan sin días; HomePage muestra su propia bienvenida.
  if (!currentDay) return null;

  const pct = Math.round(dailyProgress * 100);

  return (
    <div className="mb-5">
      <div className="flex items-center justify-between">
        <div className="flex-1 min-w-0">
          <h2 className="text-foreground font-bold text-xl sm:text-2xl tracking-tight truncate">
            {currentDay.name}
          </h2>
          <p className="text-muted-foreground text-xs font-medium mt-0.5">
            {currentDay.exercises.length}{" "}
            {currentDay.exercises.length === 1 ? "ejercicio" : "ejercicios"}
            {daily.total > 0 ? ` · ${daily.done}/${daily.total} series` : ""}
          </p>
        </div>

        {/* Con un solo ejercicio no hay nada que ordenar. */}
        {currentDay.exercises.length > 1 && (
          <button
            onClick={() => setReorderOpen(true)}
            aria-label="Reordenar ejercicios"
            className="flex-shrink-0 ml-3 h-9 w-9 rounded-full glass-surface flex items-center justify-center text-muted-foreground hover:text-foreground transition-colors"
          >
            <ArrowUpDown className="h-4 w-4" />
          </button>
        )}

        {daily.total > 0 && (
          <div className="flex-shrink-0 ml-2">
            <span
              className={`inline-block text-xs font-bold px-3 py-1.5 rounded-full border ${
                dailyProgress >= 1
                  ? "bg-success/12 border-success/30 text-success"
                  : "bg-primary/12 border-primary/30 text-primary"
              }`}
            >
              {pct}%
            </span>
          </div>
        )}
      </div>

      {daily.total > 0 && (
        <div className="mt-3">
          <Progress
            value={pct}
            className="h-1.5 bg-border/60 rounded-full"
            style={{
              '--progress-color': dailyProgress >= 1 ? 'hsl(var(--success))' : 'hsl(var(--primary))'
            }}
          />
        </div>
      )}

      <ReorderExercisesDialog
        open={reorderOpen}
        onOpenChange={setReorderOpen}
        exercises={currentDay.exercises}
        onSave={reorderExercises}
      />
    </div>
  );
}
